import { TeContainer, TeDivider, TePlaceholderContainer } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { use, useState } from 'react';

import { ServiceAgreementStepActions } from './ServiceAgreementStepActions';
import { useServiceAgreementWithId } from '../../pages/Customers/customers.queries';
import { ReviewResultContextType } from '../../providers/ReviewResultContext/review-result.types';
import { ReviewResultContext } from '../../providers/ReviewResultContext/review-result.context';
import { EulaView } from '../Eula';

interface TermsAndConditionsStepProps {
  id: string;
  visible: boolean;
  onNextStep: () => void;
  onPreviousStep?: () => void;
}

function TermsAndConditionsStep({
  id,
  visible,
  onNextStep,
  onPreviousStep,
}: TermsAndConditionsStepProps) {
  const { t } = useTranslation();
  const { isLoading: isServiceAgreementLoading } = useServiceAgreementWithId(id);
  const { setResult } = use<ReviewResultContextType>(ReviewResultContext);
  const [eulaDisclaimerAccepted, setEulaDisclaimerAccepted] = useState<boolean>(false);

  if (!visible) return;

  if (isServiceAgreementLoading) {
    return <TePlaceholderContainer loader text={t('loading', { ns: 'settings' })} />;
  }

  const handleReject = () => {
    setResult('declined');
  };

  return (
    <TeContainer justifyContent="space-between" fill padding={0} gap={0} column>
      <EulaView onChecked={(checked) => setEulaDisclaimerAccepted(checked)} />
      <TeDivider dividerColor="border.secondary" />
      <ServiceAgreementStepActions
        step="termsAndConditions"
        id={id}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
        onReject={handleReject}
        isNextStepDisabled={!eulaDisclaimerAccepted}
      />
    </TeContainer>
  );
}

export default TermsAndConditionsStep;
